export const CREATE_PROJECTSUGGESTIONCOMMENT_REQUEST = 'CREATE_PROJECTSUGGESTIONCOMMENT_REQUEST';
export const CREATE_PROJECTSUGGESTIONCOMMENT_SUCCESS = 'CREATE_PROJECTSUGGESTIONCOMMENT_SUCCESS';
export const CREATE_PROJECTSUGGESTIONCOMMENT_FAILURE = 'CREATE_PROJECTSUGGESTIONCOMMENT_FAILURE';